import React from 'react';
// import { Formik, Form, Field, ErrorMessage } from 'formik';
// import * as Yup from 'yup';
import { NavLink } from 'react-router-dom';
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { getCDNUrl } from "../../utils/cdnUtils";
import Frame from "../../assets/FrameLogin.48a2706802915ab907b841f4d97e7356.jpg";
import { GetLoginURL } from "./Services";
import LoaderTemplate from "../../components/LoaderTemplate";

const Login = ({handleClose}) => {
  const [loading, setLoading] = useState(false);

  const loginFunction = async () => {
    setLoading(true);
    await GetLoginURL().then((response) => {
      if (response.data.code === 200) {
        const currentPathName = window.location.pathname;
        window.location.href = `${response.data.data.url}&RelayState=${currentPathName}`;
      }
      setLoading(false);
      handleClose();
    }).catch((error) => {
      console.error("Error fetching login URL:", error);
      setLoading(false);
      handleClose();
    });
  }

  return (
    <div>
      {/* Start Generic Loader */}
      {loading && <LoaderTemplate />}
      {/* End Generic Loader */}
      <div className="row modal-login">
        <div className="col-lg-6">
          <div class="popup-left">
            <div class="logo-section">
              <img src={getCDNUrl(Frame)} alt="Login Frame" /> 
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="right-popup">
              <span>Welcome To:</span>
              <h2>Islamic Development Bank</h2>
              <p>
                Sign in to your IsDB account to access a
                wide range of development tools, knowledge
                resources, project data, and collaborative
                platforms. Whether you're a partner, member,
                researcher, or staff, this secure portal
                enables you to stay connected, submit
                requests, and contribute to our mission of
                advancing economic development and social
                progress across member countries.
              </p>
              <a className="btn btn-link" onClick={loginFunction}>
                <button className="btn btn-primary btn-custom slide-right-effect">Sign In</button>
              </a>
              <NavLink to="/register" className="btn btn-link" onClick={handleClose}>
                <button className=" btn-custom btn btn-outline-primary slide-right-effect">
                  Don't Have Account ? <span>Sign Up</span>
                </button>
              </NavLink>
            </div>
          </Modal.Body>
        
        </div>
      </div>
    </div>
 
   
  );
};

export default Login;
